import firebase from "firebase";

const config = {
    apiKey: "AIzaSyC3Z_fqmvJC-NTdcn-K3rCFZ5x9nDct1eI",
    authDomain: "outa-tube.firebaseapp.com",
    projectId: "outa-tube",
    storageBucket: "outa-tube.appspot.com",
    messagingSenderId: "264290322754",
    appId: "1:264290322754:web:fd61ee4905660262c720db",
    measurementId: "G-8HR0HYL80J"
};

firebase.initializeApp(config);

export default firebase;